import React from 'react';
import AppRoutings from './routings';

function App() {
	return <AppRoutings />;
}

export default App;
